// DO NOT EDIT -- generated from Go package fs/services/emissary/tsexport

///////////
// Enums //
///////////

export enum IntegrationServiceId {
	Slack = "slack",
	MsTeams = "ms-teams",
	Trello = "trello",
	DestinationWebhooks = "destination-webhooks",
	Productboard = "productboard"
}

export enum IntegrationConfigOrigin {
	INTEGRATION_CONFIG_ORIGIN_EMISSARY = "emissary",
	INTEGRATION_CONFIG_ORIGIN_METRIC_ALERTS = "metric alerts",
	INTEGRATION_CONFIG_ORIGIN_DATA_DESTINATIONS = "data destinations"
}

export enum IntegrationConfigProperty {
	INTEGRATION_CONFIG_PROPERTY_WEBHOOKS_SECRET = "secret"
}


///////////////
// Constants //
///////////////

export const JiraIntegrationName: string = "Jira";
export const ProductboardIntegrationName: string = "Productboard";
export const SlackIntegrationName: string = "Slack";
export const TrelloIntegrationName: string = "Trello";
export const WebhooksMinSecretLength: number = 8;
export const WEBHOOKS_MAPPING_FIELD_URL: string = "url";
export const WEBHOOKS_MAPPING_FIELD_URL_HOST: string = "host";
export const WEBHOOKS_MAPPING_FIELD_URL_PATH: string = "path";
export const WEBHOOKS_MAPPING_FIELD_URL_QUERY: string = "query";
export const WEBHOOKS_MAPPING_FIELD_HEADERS: string = "headers";
export const WEBHOOKS_MAPPING_FIELD_BODY: string = "body";
